<template>
  <div class="checkbox-group">
    <h2>{{title}}</h2>
    <div ref="list" class="list">
      <v-checkbox hide-details v-model="internalCheckedItems" v-for="item in items" :key="getItemId(item)" :label="getItemLabel(item)" :value="getItemId(item)" :disabled="disabled || getItemDisabled(item)" :data-testid="dataTestid"></v-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checkedItems'
  },
  props: {
    title: String,
    // items can be a list of plain strings or an object in the form ({id: x, label: y: disabled: false})
    items: Array,
    checkedItems: Array,
    disabled: Boolean,
    disabledItems: Array,
    dataTestid: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      internalCheckedItems: this.checkedItems,
      itemCount: this.items.length
    }
  },
  methods: {
    isDisabled(item) {
      if (this.disabledItems == null) return false;
      return this.disabledItems.includes(item);
    },
    scrollToBottom() {
      this.$refs.list.scrollTop = this.$refs.list.scrollHeight;
    },
    getItemId(item) {
      if (typeof item == 'string') {
        return item;
      }
      else {
        return item.id;
      }
    },
    getItemLabel(item) {
      if (typeof item == 'string') {
        return item;
      }
      else {
        if (item.label != undefined) return item.label;
        return item.id;
      }
    },
    getItemDisabled(item) {
      if (typeof item == 'string') {
        return false;
      }
      else {
        if (item.disabled != undefined) return item.disabled;
        return false;
      }
    }
  },
  watch: {
    items(items) {
      // scroll down automatically if items were added
      if (items.length > this.itemCount) {
        this.$nextTick(() => this.scrollToBottom());
      }
      this.itemCount = items.length;
    },
    checkedItems(items) {
      this.internalCheckedItems = items;
    },
    internalCheckedItems(items) {
      this.$emit('input', items);
    }
  }
}
</script>

<style scoped lang="scss">
.checkbox-group {
  .list {
    max-height: 200px;
    overflow: auto;
    padding-top: 8px;
    padding-bottom: 15px;
  }
  .v-input--selection-controls {
    margin-top: 0;
    margin-bottom: 0;
    //padding-top: 0;
    //padding-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/CheckboxGroup.vue